<template>
  <div class="w-[100%] h-[100%]">
    <el-dropdown ref="dropdownRef" trigger="click" class="dropdown">
      <slot name="trigger">
        <span class="el-dropdown-link t-[12] t-[#526075]"> {{ label }}<i
            class="icon cursor-pointer status-icon-hover">&#xe6b0;</i> </span>
      </slot>
      <el-dropdown-menu slot="dropdown" :hide-on-click="false">
        <div class="drop">
          <div style="width: 100%">
            <el-input v-model="input" @input="inputEvent" class="input" size="mini" prefix-icon="el-icon-search"
              placeholder="搜索" clearable style="width: 100%"> </el-input>
          </div>
          <el-checkbox-group v-model="isCheckIdList" v-if="options.length > 0" :max="isMultiple ? 999 : 1">
            <div class="checkboxLists">
              <el-checkbox v-for="item in options" :label="item[keys].toString()" :key="item[keys].toString()"
                style="display: block" class="checiboxItem">
                {{ item.value || item.label }}
              </el-checkbox>
            </div>
          </el-checkbox-group>
          <div v-else class="noData">无数据</div>
          <div class="footer">
            <el-button type="primary" plain size="mini" class="footer_close" @click="handleClose"> 关 闭 </el-button>
            <el-button type="primary" size="mini" class="footer_sure" @click="determine"> 确 定 </el-button>
          </div>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
/*
 *
 * 数据说明
 * 传进来的数据
 * checkBoxList 里面item一定有key是id，表示唯一值，label用来展示
 * checkBoxList: [{ id: "1", label: "张三", age: 5 },{ id: "2", label: "李四", age: 6 }] // 表示传进来的列表
 * defaultCheckBoxList:['1', '2', '3'] // 默认选中的值
 * keys: "id" // 表示 表示唯一值字段名称
 *
 * 向父级传值：
 * let obj = {
 *  initList, // 原始数组值
 *  initIsCheckId, // 原始id列表值
 *  isCheckIdList, // 选中的id列表值
 *  isCheckEdItem, // 选中的item列表值
 * };
 * this.$emit("checked", obj); // 把选中的信息抛出
 */

export default {
  name: "DgSearchHeader",
  props: {
    url: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "下拉菜单",
    },
    keys: {
      type: String,
      default: "id", // 模拟数据 唯一值 是id
    },
    params: {
      type: Object,
      default: () => { },
    },
    isMultiple: {
      type: Boolean,
      default: false, // 模拟数据 是否多选
    },
    propOptions: {
      type: Array,
      default: () => [],
    },
    currentKey: {
      type: String,
      default: "id", // 模拟数据 当前选中的key
    },
    noAjax: {
      type: Boolean,
      default: false, // 否不请求接口
    },
  },
  data() {
    return {
      input: "",
      isCheckIdList: [], // 选中的
      options: [],
    };
  },
  // watch: {
  //   url: {
  //     deep: true,
  //     immediate: true,
  //     handler(newVal, oldVal) {
  //       if (newVal !== oldVal) {
  //         this.loadOptions(newVal);
  //       }
  //     },
  //   },
  // },

  created() {
    this.loadOptions();
  },
  mounted() {
    this.$bus.$on(`handleClearHeaderCheckout${this.currentKey}`, () => {
      this.isCheckIdList = [];
    })
    this.$bus.$on(`handleClearHeaderCheckout`, () => {
      this.isCheckIdList = [];
    })
  },

  methods: {
    // 加载选项配置
    loadOptions() {
      if (this.url && this.url != '/customer/status' && !this.noAjax) {
        ajax.post({
          self: this,
          url: this.url,
          data: this.params || {},
          success: (res) => {
            this.options = res;
          }
        });
      } else {
        this.options = this.deepClone(this.propOptions); // 深拷贝一下
      }
    },

    // 关闭下拉框
    handleClose() {
      this.$refs.dropdownRef.hide(); // 关闭下拉框
    },

    // 确定
    determine() {
      let { keys, isCheckIdList } = this;
      let isCheckEdItem = this.options.filter((x) => isCheckIdList.includes(x[keys] + ""));
      let initList = this.deepClone(this.options);
      let obj = {
        initList, // 原始数组值
        isCheckIdList, // 选中的id列表值
        isCheckEdItem, // 选中的itemList值
        currentKey: this.currentKey,
        label: this.label,
      };
      this.$emit("checked", obj); // 把选中的信息抛出
      this.handleClose();
    },

    // 输入事件
    inputEvent(val = "") {
      val = (val + "").toLowerCase();
      let arr = [];
      if (val === "") return;
      arr = this.options.filter((x) => x.value.includes(val));
      this.options = arr;
    },

    // 深拷贝
    deepClone(source) {
      if (typeof source !== "object" || source == null) {
        return source;
      }
      let target = Array.isArray(source) ? [] : {};
      for (let key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          if (typeof source[key] === "object" && source[key] !== null) {
            target[key] = this.deepClone(source[key]);
          } else {
            target[key] = source[key];
          }
        }
      }
      return target;
    },
  },
};
</script>

<style lang="less" scoped>
.status-icon-hover {
  &:hover {
    color: var(--primary-color);
  }
}

.dropdown {
  cursor: pointer;
}

.drop {
  padding: 10px;
}

.input {
  width: 100px;
  margin: 0 auto;
  width: 100%;
}

.checkAlls {
  margin-top: 5px;
  padding-bottom: 5px;
  display: block;
}

.checkAllLine {
  width: 75%;
  border-bottom: 1px solid #e4e4e4;
  margin: 0 auto;
}

.checkboxLists {
  max-height: 260px;
  padding-right: 10px;
  overflow-y: scroll;

  .checiboxItem {
    margin: 6px 0;
  }
}

.noData {
  margin: 20px 0;
  font-size: 14px;
  color: #ccc;
  width: 100%;
  text-align: center;
}

.footer {
  margin-top: 15px;
  width: 100%;
  text-align: center;

  .footer_sure {
    margin-left: 20px;
  }
}
</style>
